<template>
  <div class="ld-nomore">
    <van-divider :style="{color:fontColor}">{{ text }}</van-divider>
  </div>
</template>

<script>
import {Divider} from 'vant'

export default {
  data() {
    return {}
  },
  components: {
    [Divider.name]: Divider,
  },
  props: {
    text: {
      type: String,
      default: '没有更多数据了~'
    },
    fontColor: {
      type: String,
      default: '#969799'
    }
  }
}
</script>
